import SpaceLabel from "./SpaceLabel";

export default SpaceLabel;
